// extracted by mini-css-extract-plugin
export default {"box-icons__items":"BoxIcons_box-icons__items__C4StZ","box-icons__title":"BoxIcons_box-icons__title__2KsZv","box-icons__title-selected":"BoxIcons_box-icons__title-selected__8M+vR"};